import React from 'react';
import { FormLocaleDatePicker } from '@ianesthesie-kit/form';
import { TranslatedText } from '@ianesthesie-kit/core';
import { isPast, isToday } from 'date-fns';
import { useFormikContext } from 'formik';
import type { DirectPatientSchema } from '@/components/drawer/newPatientDrawer/patient.schema';

const NOW = new Date();

export const SurgeryDateField = () => {
  const {
    values: { urgentCareNeeded }
  } = useFormikContext<DirectPatientSchema>();
  return (
    <FormLocaleDatePicker
      name="surgeryDate"
      label={<TranslatedText id="doctor-dashboard.dashboard.surgeryDate" />}
      formControlProps={{ margin: 'normal' }}
      defaultCalendarMonth={NOW}
      shouldDisableDate={(d) =>
        urgentCareNeeded ? isPast(d) && !isToday(d) : isPast(d) || isToday(d)
      }
    />
  );
};

export const DeadlineField = () => (
  <FormLocaleDatePicker
    name="deadline"
    defaultCalendarMonth={NOW}
    minDate={NOW}
    label={<TranslatedText id="app.user.deadline" />}
    formControlProps={{ margin: 'dense' }}
  />
);
